import { get, post, put } from '@/lib/http';
import { endpoints } from './endpoints';
import type {
  RegisterTenantRequest,
  RegisterTenantResponse,
  SlugAvailability,
  Tenant,
  UpdateTenantRequest,
} from '@/types';

/**
 * Workspaces — self-service sign-up plus the platform-operator admin surface.
 *
 * `register`/`slugAvailable`/`current` are reachable by anyone (the first two
 * before sign-in even); `list`/`byId`/`update` need `TENANT_VIEW`/`TENANT_MANAGE`,
 * which only the seeded platform-admin account holds.
 */
export const tenantApi = {
  register: (body: RegisterTenantRequest) =>
    post<RegisterTenantResponse, RegisterTenantRequest>(endpoints.tenants.register, body),

  slugAvailable: (slug: string) =>
    get<SlugAvailability>(endpoints.tenants.slugAvailable, { params: { slug } }),

  current: () => get<Tenant>(endpoints.tenants.current),

  list: () => get<Tenant[]>(endpoints.tenants.list),

  byId: (id: number) => get<Tenant>(endpoints.tenants.byId(id)),

  update: (id: number, body: UpdateTenantRequest) =>
    put<Tenant, UpdateTenantRequest>(endpoints.tenants.byId(id), body),
};
